// @ts-nocheck
import { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { Card } from 'primereact/card';
import { InputSwitch } from 'primereact/inputswitch';
import "../../assets/functionalComponents/_dialog.scss"
import "../../assets/functionalComponents/_dataItem.scss"

export const PipelineOption = (props) => {
    const [layer, setLayer] = useState({});
    const [optionOpen, setOptionOpen] = useState(false);
    const [entityFlowtoggle, setEntityFlowtoggle] = useState(false);

    useEffect(() => {
        setLayer(props.layer)
        if (props.layer.layerSetting) {
            setOptionOpen(props.layer.layerSetting.optionOpen);
            setEntityFlowtoggle(props.layer.layerSetting.entityFlowtoggle);
        }
    }, [props.layer])

    useEffect(() => {
        let item = props.layer;
        item.layerSetting = {
            optionOpen: optionOpen,
            entityFlowtoggle: entityFlowtoggle
        };
        props.layerUpdate(item, props.index);
    }, [optionOpen, entityFlowtoggle])

    useEffect(() => {
        props.layer.layerObject.setDrawAllFlow(entityFlowtoggle);
        if (entityFlowtoggle) {
            props.layer.layerObject.setFlowUseTexture(false);
            props.layer.layerObject.setFlowTextureMaxDensity(null, 1);
            props.layer.layerObject.setFlowColorWeight(0.5, 0.5, 0.5);
        }
    }, [entityFlowtoggle, props.layer])

    const setClipPolygon = () => {
        window.main.OView.inputSurfacePolygon({
            onCompleted: function (result) {
                if (result.success) {
                    props.layer.layerObject.addClipPolygon(result.geo, window.ov.CLIP_MODE.REMOVE);
                }
            }
        });
    }

    const removeClipPolygon = () => {
        props.layer.layerObject.removeClipPolygon();
    }

    const OptionCard = () => {
        return (
            <Card style={{ marginTop: "1rem" }}>
                <div className="field grid">
                    <label class="col-12 mb-4 md:col-4 md:mb-0">管線流向：</label>
                    <div className="col-12 md:col-8">
                        <InputSwitch checked={entityFlowtoggle} onChange={(e) => setEntityFlowtoggle(e.value)} />
                    </div>
                </div>
                <div className="field grid">
                    <label class="col-12 mb-4 md:col-4 md:mb-0">管線裁切：</label>
                    <div className="col-12 md:col-4">
                        <Button label="新增區域" icon="pi pi-check" className="p-button-rounded p-button-info" onClick={setClipPolygon} style={{ width: "100%" }} />
                    </div>
                    <div className="col-12 md:col-4">
                        <Button label="清除裁切" icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={removeClipPolygon} style={{ width: "100%" }} />
                    </div>
                </div>
            </Card>
        )
    }
    const layerGoto = () => {
        layer.layerObject.goto();
    }

    return (
        <div>
            <div className="layer-item">
                <div className="layer-detail">
                    <div className="layer-name">{layer.TITLE}</div>
                </div>
                <div className="layer-action">
                    {
                        props.layer.CLASS === "Pipeline" ?
                            <Button icon="pi pi-cog" className="p-button-rounded p-button-info" onClick={() => { setOptionOpen(!optionOpen) }} /> :
                            <Button icon="pi pi-cog" className="p-button-rounded p-button-info" disabled />
                    }
                    <Button icon="pi pi-map-marker" className="p-button-rounded p-button-info" onClick={() => { layerGoto() }} />
                    <Button icon="pi pi-times" className="p-button-rounded p-button-danger" onClick={() => { props.layerRemove(props.index) }} />
                </div>
            </div>
            {
                optionOpen ? OptionCard() : null
            }
            <Divider />
        </div>
    )
}